<template>
  <v-dialog v-model="localDialog" scrollable width="854" lazy>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          {{
            localParticipant._id
              ? $t('titles.global.updateModel', {
                  field: $tc('titles.tournaments.participant'),
                })
              : $t('titles.global.newModel', {
                  field: $tc('titles.tournaments.participant'),
                })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap>
          <template v-if="!participant._id">
            <v-flex xs12>
              <v-layout wrap>
                <v-flex md6 xs12 px-2>
                  <entity-field
                    v-model="entityId"
                    :label="
                      $t('action.actions.select', {
                        field: $t('models.entity'),
                      })
                    "
                    @change="localParticipant.objectId = ''"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-flex>
          </template>

          <v-flex v-if="type === 'teams'" md6 xs12 px-2>
            <team-field
              v-model="localParticipant.objectId"
              v-validate="'required'"
              :entity-id="entityId"
              :readonly="!!participant._id"
              :label="
                $t('action.actions.select', { field: $tc('models.team') }) +
                ' (*)'
              "
              :data-vv-name="$tc('models.team')"
              :error-messages="errors.collect($tc('models.team'))"
            />
          </v-flex>
          <v-flex v-else-if="type === 'users'" xs12 md6 px-2>
            <user-field
              v-model="localParticipant.objectId"
              v-validate="{ required: type === 'users' }"
              :entity-id="entityId"
              :readonly="!!participant._id"
              type-role="player"
              :label="$tc('titles.global.player') + ' (*)'"
              :data-vv-name="$tc('titles.global.player')"
              :error-messages="errors.collect($tc('titles.global.player'))"
            />
          </v-flex>

          <v-flex md3 xs6 px-2>
            <v-switch
              v-model="localParticipant.confirmed"
              :disabled="disabled && !localParticipant.confirmed"
              :label="$t('fields.tournaments.confirmed')"
              color="primary"
            />
          </v-flex>
          <v-flex md3 xs6 px-2>
            <v-switch
              v-model="localParticipant.inscribed"
              :disabled="disabled && !localParticipant.inscribed"
              :label="$t('fields.tournaments.inscribed')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <template>
          <span style="color: red">(*) &nbsp;</span>
          <span>{{ $t('action.messages.fieldRequired') }}</span>
        </template>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button type="cancel" @click="cancel" />
        <meta-button
          v-if="!localParticipant._id"
          type="create"
          :loading="loading"
          @click="submit"
        />
        <meta-button v-else type="update" :loading="loading" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
export default {
  name: 'DialogParticipant',
  components: { EntityField, TeamField },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
    },
    participant: {
      type: Object,
      default: () => {},
      required: true,
    },
    participantIds: {
      type: Array,
      default: () => [],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      entityId: '',
      searchEntity: '',
      searchTeam: '',
      searchUser: '',
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        if (!this.localParticipant.objectId) this.debounceTeams()
        if (!this.entityId) this.debounceEntities()
      }
    },
    entityId(val) {
      if (val) {
        if (this.type === 'users') {
          this.fetchUsers({ entity: val, typeRole: 'player' })
        } else if (this.type === 'teams') {
          this.fetchTeams({ entityId: val })
        }
      } else {
        this.searchEntity = ''
        if (this.type === 'users') {
          this.fetchUsers({
            match: this.searchUser,
            typeRole: 'player',
          })
        } else if (this.type === 'teams') {
          this.fetchTeams({ match: this.searchTeam })
        }
      }
    },
    'localParticipant.objectId': {
      handler: function (val, oldVal) {
        if (val && !oldVal) {
          if (this.type === 'users') this.fetchUsers({ _id: val })
          else if (this.type === 'teams') this.fetchTeams({ _id: val })
        } else if (oldVal && !val) {
          this.searchTeam = ''
          this.searchUser = ''
          //   if (this.type === 'users') {
          //     let params = {}
          //     if (this.entityId) params.entity = this.entityId
          //     this.fetchUsers(params)
          //   } else if (this.type === 'teams') {
          //     let params = {}
          //     if (this.entityId) params.entityId = this.entityId
          //     this.fetchTeams(params)
          //   }
        }
      },
    },
    searchEntity(val) {
      if (!this.entityId) {
        this.debounceEntities({ match: val })
      }
    },
    searchUser(val) {
      if (!this.localParticipant.objectId) {
        let params = { match: val, typeRole: 'player' }
        if (this.entityId) params.entity = this.entityId
        this.debounceUsers(params)
      }
    },
    searchTeam(val) {
      if (!this.localParticipant.objectId) {
        let params = { match: val }
        if (this.entityId) params.entityId = this.entityId
        this.debounceTeams(params)
      }
    },
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapState({
      tournament: (state) => state.tournaments.selected,
    }),
    ...mapGetters({
      teamSelectList: 'teams/selectList',
      userSelectList: 'users/selectList',
      entitySelectList: 'entities/selectList',
    }),
    localDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        if (!value) this.cancel()
      },
    },
    localParticipant: {
      get() {
        return this.participant
      },
      set(value) {
        this.$emit('update:participant', value)
      },
    },
    teamList() {
      return this.teamSelectList.filter(
        (item) =>
          item.value === this.participant.objectId ||
          !this.participantIds.includes(item.value)
      )
    },
    userList() {
      return this.userSelectList.filter(
        (item) => !this.participantIds.includes(item.value)
      )
    },
  },
  methods: {
    ...mapActions({
      fetchTeams: 'teams/fetchSelectList',
      fetchUsers: 'users/fetchSelectList',
      fetchEntities: 'entities/fetchSelectList',
    }),
    submit() {
      this.validate().then((valid) => {
        if (!valid) return
        this.$emit('submit')
      })
    },
    reset() {
      this.entityId = ''
      this.localParticipant = {
        objectId: '',
        confirmed: false,
        inscribed: false,
      }
    },
    clear() {
      this.$nextTick(() => {
        this.reset()
        this.$validator.reset()
      })
    },
    cancel() {
      this.$emit('update:dialog', false)
      this.clear()
    },
  },
}
</script>
